<template>
  <div>
    <div v-if="overflowDetected" class="scroll-overflow-indicator">
      <div class="scroll-indicator">
        <svg :class="{ 'scrolled-down': scrolledToBottom }">
          <use :href="`${spritemap}#svg-chevron-down`"></use>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    spritemap: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      overflowDetected: false,
      scrolledToBottom: false,
      contentElement: null,
    }
  },
  mounted() {
    this.contentElement = this.$el.previousElementSibling // TODO: find a better way to grab the element
    this.checkOverflow()
  },
  beforeUnmount() {
    this.contentElement.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    checkOverflow() {
      if (
        this.contentElement &&
        this.contentElement.scrollHeight > this.contentElement.clientHeight
      ) {
        this.overflowDetected = true
        this.contentElement.addEventListener('scroll', this.handleScroll)
      } else {
        this.overflowDetected = false
      }
    },
    handleScroll() {
      const tolerance = 10 // Tolerance value in pixels
      if (
        this.contentElement.scrollHeight - this.contentElement.scrollTop <=
        this.contentElement.clientHeight + tolerance
      ) {
        this.scrolledToBottom = true
      } else {
        this.scrolledToBottom = false
      }
    },
  },
}
</script>

<style scoped lang="postcss">
.scroll-overflow-indicator {
  padding-top: 24px;

  .scroll-indicator {
    position: absolute;
    display: block;
    width: 48px;
    height: 15px;
    text-align: center;
    background: var(--color-green);
    bottom: 2px;
    left: 0;
    right: 0;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: black;
    border-radius: 999px;

    svg {
      width: 8px;
      height: 8px;
      transition: transform var(--ani-speed-3) var(--ani-type-1);

      &.scrolled-down {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
